import { styled } from 'styled-components'
import { screen } from '../../styles/mq'
export const HomeContainer = styled.div`
  padding-top: 2.4rem;
  display: flex;
  justify-content: space-between;
  gap: var(--padding-m);
  margin: auto;
  @media (max-width: ${screen.m}) {
    max-width: 520px;
    display: block;
    h2 {
      text-align: center;
    }
  }
`
export const LeftContainer = styled.div`
  position: sticky;
  width: 40%;
  top: 0;
  max-height: 100vh;
  span {
    color: var(--highlight);
  }
  a {
    text-decoration: none;
    border-bottom: none;
    margin-right: 8px;
  }
  @media (max-width: ${screen.m}) {
    position: relative;
    width: 100%;
    max-height: none;
  }
`
export const RightContainer = styled.div`
  width: 60%;
  @media (max-width: ${screen.m}) {
    width: 100%;
  }
`
export const Frame = styled.div`
  margin: 1.6rem 0;
  padding: var(--padding-m);
  border-radius: 6px;
  border: 1px solid rgba(77, 111, 145, 0.5);
  &.columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.6rem;
  }
  > div:first-child {
    border-right: 1px solid rgba(77, 111, 145, 0.5);
  }
  @media (max-width: ${screen.xs}) {
    padding: var(--padding-s);
  }
`
export const Skill = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-left: 12px;
  }
  @media (max-width: ${screen.xs}) {
    margin-left: 8px;
  }
`

export const Box = styled.div`
  width: 200px;
  height: 100px;
  background-color: rgba(30, 41, 59, 0.5);
`

export const PortraitContainer = styled.div`
  padding: 4px;
  border-radius: 6px;
  border: 1px solid rgba(77, 111, 145, 0.5);
  width: 176px;
  line-height: 0;
  img {
    border-radius: 6px;
    width: 100%;
  }
  @media (max-width: ${screen.m}) {
    margin: auto;
    margin-block: 1em;
  }
`
